<script setup>
// Renderiza a mensagem de BOTÕES enviada pelo atendente (resposta rápida ou CTA)
// via AstraCall. Formato do content (gerado no send_rich):
//   "🔘 <texto>\n▫️ Botão A\n▫️ Botão B"   (buttons)
//   "🔘 <texto>\n💬/🔗/📋/📞 Rótulo"        (interactive/CTA)
// Detecção/roteamento no Message.vue (marcador 🔘 no início). É só exibição — a
// resposta do cliente volta como mensagem de texto normal (via ponte AstraCalls).
import { computed } from 'vue';
import { useMessageContext } from '../provider.js';
import BaseBubble from 'next/message/bubbles/Base.vue';

const { content } = useMessageContext();

const parsed = computed(() => {
  const raw = String(content?.value || '');
  const lines = raw.split('\n').map(l => l.trim()).filter(Boolean);
  const text = (lines[0] || '').replace(/^\u{1F518}\s*/u, '').trim();
  // rótulos = linhas seguintes, sem o marcador/emoji/■ inicial
  const buttons = lines
    .slice(1)
    .map(l => l.replace(/^[▫◾\u{1F4AC}\u{1F517}\u{1F4CB}\u{1F4DE}\-•]️?\s*/u, '').trim())
    .filter(Boolean);
  return { text, buttons };
});
</script>

<template>
  <BaseBubble
    class="!p-3.5 !max-w-[300px] min-w-[220px]"
    data-bubble-name="interactive-buttons"
    hide-meta
  >
    <div class="flex flex-col gap-2.5">
      <div class="font-medium leading-snug whitespace-pre-line text-n-slate-12">
        {{ parsed.text }}
      </div>
      <div class="flex flex-col gap-1.5">
        <div
          v-for="(b, i) in parsed.buttons"
          :key="i"
          class="flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-center rounded-lg outline outline-1 outline-n-weak bg-n-alpha-1 text-n-brand"
        >
          {{ b }}
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
